import {
  Component,
  Input,
  CUSTOM_ELEMENTS_SCHEMA,
  Output,
  EventEmitter,
} from '@angular/core';
import type { LeafTag } from '@cigna/leaf-web/lib/wc';

import '@cigna/leaf-web/lib/wc/components/tag/tag';

@Component({
  selector: 'cigna-leaf-tag',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-tag
      [text]="text"
      [type]="type"
      [variant]="variant"
      [shape]="shape"
      [isDisabled]="isDisabled"
      [isSelected]="isSelected"
      [fieldId]="fieldId"
      [value]="value"
      (change)="change.emit($event.detail?.isSelected)"
    ></leaf-tag>
  `,
})
export class CignaLeafTagComponent {
  @Input() text: LeafTag['text'];
  @Input() type: LeafTag['type'];
  @Input() variant: LeafTag['variant'];
  @Input() shape: LeafTag['shape'];
  @Input() isDisabled: LeafTag['isDisabled'];
  @Input() isSelected: LeafTag['isSelected'];
  @Input() fieldId: LeafTag['fieldId'];
  @Input() value: LeafTag['value'];

  /**
   * ********
   * CUSTOM ANGULAR PROPERTIES
   */
  @Output() change = new EventEmitter<boolean>();
}
